import React, { useState, useEffect } from "react"
import axios from "axios"
import Spinners from "components/Common/Spinner"
import moment from "moment/moment"
import {
  Badge,
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Container,
  Card,
  CardBody,
  CardImg,
  Row,
  Col,
} from "reactstrap"
import { useParams, Link } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"

const ResuableComponent = ({ data: initialData }) => {
  const { id } = useParams()
  const assignment_id = id
  const [data, setData] = useState(initialData)
  const [modal, setModal] = useState(false)
  const [Loading, setLoading] = useState(false)
  const [currentAttachments, setCurrentAttachments] = useState([])
  const token = JSON.parse(localStorage.getItem("Token"))

  const downloadAllAttachments = async () => {
    for (const url of currentAttachments) {
      const link = document.createElement("a")
      link.href = encodeURI(url)
      link.download = url.split("/").pop() || "attachment"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      await new Promise(resolve => setTimeout(resolve, 500))
    }
  }

  const toggle = () => setModal(!modal)

  const handleRemarkChange = (id, value) => {
    setData(prevData =>
      prevData.map(item =>
        item.id === id ? { ...item, remarks: value } : item
      )
    )
  }
  const handleSubmit = async id => {
    const updatedItem = data.find(item => item.id === id)
    setLoading(true)
    try {
      await axios({
        method: "POST",
        url: "https://marcopolo.prisms.in/api/Assignment/submit-remark",
        data: {
          assignment_id: assignment_id,
          student_id: updatedItem.id,
          remark: updatedItem.remarks,
        },
        headers: {
          Authorization: token,
        },
      }).then(res => {
        toast.success(res.data.message)
        setLoading(false)
      })
    } catch (error) {
      console.error("Error fetching leave data:", error)
      setLoading(false)
    }
  }
  const combined = {}

  data.forEach(student => {
    if (!combined[student.id]) {
      combined[student.id] = {
        ...student,
        locations: student.location !== "0" ? [student.location] : [],
      }
    } else {
      if (student.location !== "0") {
        combined[student.id].locations.push(student.location)
      }
      // Update to the latest submission date if needed
      if (
        student.submitted_date &&
        student.submitted_date > combined[student.id].submitted_date
      ) {
        combined[student.id].submitted_date = student.submitted_date
      }
    }
  })

  // Convert to array
  const result = Object.values(combined)
  // console.log(result)
  return (
    <div>
      {result &&
        result.map((item, index) => (
          <div
            key={index}
            style={{
              backgroundColor: "#fff",
              borderRadius: "4px",
              marginTop: "5px",
              padding: "15px",
              position: "relative",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div className="d-flex justify-content-between">
              <div className="w-100">
                <div className="d-flex flex-column">
                  <span className="mt-1 text-start text-dark d-flex align-items-center">
                    {item.student_name}

                    {item.locations &&
                      item.locations.length > 0 &&
                      item.locations.map((url, index) => (
                        <i
                          key={index}
                          className="bx bx-paperclip ms-2 text-primary"
                          style={{ fontSize: "18px", cursor: "pointer" }}
                          onClick={() => {
                            setCurrentAttachments(item.locations)
                            toggle()
                          }}
                          title={`Attachment ${index + 1}`}
                        ></i>
                      ))}
                  </span>

                  {item.submitted_date !== " " && (
                    <span className="d-flex justify-content-between mt-2 text-start align-items-center">
                      <div>
                        <span className="text-dark fw-medium">Date</span>:{" "}
                        {moment(item.submitted_date).format("DD-MM-YYYY")}
                      </div>
                    </span>
                  )}

                  {item.submitted_date !== " " && (
                    <div className="mt-2">
                      <Input
                        type="textarea"
                        value={item.remarks || ""}
                        onChange={e =>
                          handleRemarkChange(item.id, e.target.value)
                        }
                      />
                      <Button
                        style={{
                          border: "none",
                          backgroundColor: "#556ee6",
                        }}
                        className="btn-sm btn-rounded mt-2"
                        onClick={() => handleSubmit(item.id)}
                      >
                        Submit
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}

      <ToastContainer />
      <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader toggle={toggle}>Attachments</ModalHeader>
      <ModalBody>
        {currentAttachments && currentAttachments.length > 0 ? (
          currentAttachments.map((url, index) => {
            const isImage = /\.(jpeg|jpg|png|gif|webp)$/i.test(url);
            const isPdf = /\.pdf$/i.test(url);

            return (
              <div className="mb-4" key={index}>
                <p>
                  <strong>Attachment {index + 1}</strong>
                </p>

                {isImage ? (
                  <img
                    src={encodeURI(url)}
                    alt={`attachment-${index + 1}`}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "400px",
                      borderRadius: "8px",
                    }}
                    className="mb-2"
                  />
                ) : isPdf ? (
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    <CardImg
                      top
                      src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                      alt="PDF Icon"
                      style={{ width: "40px", height: "40px" }}
                    />
                  </a>
                ) : (
                  <span className="text-sm text-gray-600">(Preview not available for this file type)</span>
                )}
              </div>
            );
          })
        ) : (
          <p>No attachment available.</p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
        {currentAttachments.length > 1 && (
          <Button color="primary" onClick={downloadAllAttachments}>
            Download All
          </Button>
        )}
      </ModalFooter>
    </Modal>
    </div>
  )
}

const Report = () => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const token = JSON.parse(localStorage.getItem("Token"))
  const { id } = useParams()

  const getSubjectAccessReport = async () => {
    setLoading(true)
    try {
      await axios({
        method: "POST",
        url: "https://marcopolo.prisms.in/api/Assignment/view-assignment",
        data: {
          assignment_id: id,
        },
        headers: {
          Authorization: token,
        },
      }).then(res => {
        setData(res.data.data)
        setLoading(false)
      })
    } catch (error) {
      console.error("Error fetching leave data:", error)
      setLoading(false)
    }
  }

  useEffect(() => {
    getSubjectAccessReport()
  }, [])

  return (
      <Row className="mt-5 py-4">
        <Container>
          <Card>
            <CardBody>
              <h1
                className="text-center mb-4 fs-3"
                style={{ color: "#3c3c3c" }}
              >
                Assignment
              </h1>
              {loading ? (
                <Spinners />
              ) : (
                <ResuableComponent data={data || []} id={id} />
              )}
            </CardBody>
          </Card>
        </Container>
      </Row>
  )
}

export default Report

